import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { emailThreadAttachmentsKeys } from '../../../api/getEmailThreadAttachments';

const url = `${PREFIX_URL}/inbox-documents/:fileId/duplicate`;

type DuplicateEmailFileResponse = {
  data: any;
  status: boolean;
};

export type DuplicateEmailFileDTO = {
  fileId: number;
};

export const duplicateEmailFile = ({
  fileId,
}: DuplicateEmailFileDTO): Promise<DuplicateEmailFileResponse> => {
  return axios.post(generateRoutePath(url, { fileId }));
};

type DuplicateEmailFileOptions = {
  projectId: string;
  inboxEntryId: number;
  fileId: number;
  config?: MutationConfig<typeof duplicateEmailFile>;
};

export const useDuplicateEmailFile = ({
  projectId,
  inboxEntryId,
  fileId,
  config,
}: DuplicateEmailFileOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries([
        INBOX_API_KEY,
        ...emailThreadAttachmentsKeys.all,
        projectId,
        inboxEntryId,
      ]);
    },
    ...config,
    mutationFn: () => duplicateEmailFile({ fileId }),
  });
};
